import React from 'react';
import { BaseDateTimeField, type BaseDateTimeFieldProps } from './BaseDateTimeField';

export type DateTimeInputProps = BaseDateTimeFieldProps;

/**
 * Shared date+time field (VIS-136). Typed entry is the primary input; a native
 * picker is available as a secondary affordance. Value contract matches
 * <input type="datetime-local">: 'YYYY-MM-DDTHH:mm' or ''.
 */
export const DateTimeInput: React.FC<DateTimeInputProps> = (props) => (
  <BaseDateTimeField mode="datetime" {...props} />
);
